import { PropsWithChildren } from "react";
import { clsx } from "clsx";

interface SafeAreaContainerProps extends PropsWithChildren {
    className?: string;
    fullHeight?: boolean;
    customPaddingBottom?: string;
}

/**
 * 安全区域容器
 * 适配全屏底部safe area，底部带有一定程度的padding
 * @param props
 * @constructor
 */
export function SafeAreaContainer({
    children,
    className,
    fullHeight = true,
    customPaddingBottom = "12dvh",
}: SafeAreaContainerProps) {

    return (
        <div
            className={clsx(
                "flex flex-col w-full",
                fullHeight && "min-h-dvh",
                // 自定义样式
                className
            )}
            style={{ paddingBottom: customPaddingBottom }}
        >
            {children}
        </div>
    );
}
